// File for application constants

export const ADMIN_ROLE = 'ADMIN';
